import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/skill-assessment/icons/clock.svg'
import _imports_1 from '@/assets/images/skill-assessment/icons/question.svg'


const _hoisted_1 = { class: "columns container mb-4" }
const _hoisted_2 = { class: "column is-full-mobile is-half-desktop" }
const _hoisted_3 = { class: "quiz-image mb-4" }
const _hoisted_4 = { class: "is-full" }
const _hoisted_5 = { class: "has-text-centered" }
const _hoisted_6 = { class: "info-item p-3 is-radius-3 has-text-primary mx-2" }
const _hoisted_7 = { class: "medium-text" }
const _hoisted_8 = { class: "info-item p-3 is-radius-3 has-text-primary mx-2" }
const _hoisted_9 = { class: "medium-text" }
const _hoisted_10 = { class: "cta has-text-centered p-3" }
const _hoisted_11 = { class: "mb-4 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_image = _resolveComponent("dynamic-image")!
  const _component_quiz_info = _resolveComponent("quiz-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "head mb-2" }, [
      _createElementVNode("div", { class: "p-3" }, "Skill Assessment"),
      _createElementVNode("hr", { class: "m-0" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_dynamic_image, { image: _ctx.quizImage }, null, 8, ["image"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "has-text-centered bold-text is-size-5 mb-5" }, "Appliance Repair Skill Assessment", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.quizTime) + " Minutes", 1)
            ]),
            _createElementVNode("span", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.questionsPerQuiz) + " Questions", 1)
            ])
          ])
        ])
      ]),
      _createVNode(_component_quiz_info)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "is-primary button is-fullwidth py-3 medium-text",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)))
        }, "Start Assessment")
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("span", { class: "disclaimer is-size-6" }, " By starting this assessment, you agree to complete it honestly and without external assistance. ")
      ], -1))
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
  ], 64))
}